/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetIncomeMonthResponse
 */
export interface AssetIncomeMonthResponse {
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthResponse
     */
    year: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthResponse
     */
    month: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthResponse
     */
    paidAmount: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthResponse
     */
    garnishedAmount: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthResponse
     */
    expenseAllowance: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthResponse
     */
    familyAllowance: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthResponse
     */
    employerSettledExpenses: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeMonthResponse
     */
    specialPaymentPaid: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeMonthResponse
     */
    monthlyIncome: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeMonthResponse
     */
    countsTowardsAverage: boolean;
}

/**
 * Check if a given object implements the AssetIncomeMonthResponse interface.
 */
export function instanceOfAssetIncomeMonthResponse(value: object): value is AssetIncomeMonthResponse {
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('paidAmount' in value) || value['paidAmount'] === undefined) return false;
    if (!('garnishedAmount' in value) || value['garnishedAmount'] === undefined) return false;
    if (!('expenseAllowance' in value) || value['expenseAllowance'] === undefined) return false;
    if (!('familyAllowance' in value) || value['familyAllowance'] === undefined) return false;
    if (!('employerSettledExpenses' in value) || value['employerSettledExpenses'] === undefined) return false;
    if (!('specialPaymentPaid' in value) || value['specialPaymentPaid'] === undefined) return false;
    if (!('monthlyIncome' in value) || value['monthlyIncome'] === undefined) return false;
    if (!('countsTowardsAverage' in value) || value['countsTowardsAverage'] === undefined) return false;
    return true;
}

export function AssetIncomeMonthResponseFromJSON(json: any): AssetIncomeMonthResponse {
    return AssetIncomeMonthResponseFromJSONTyped(json, false);
}

export function AssetIncomeMonthResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetIncomeMonthResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'year': json['year'],
        'month': json['month'],
        'paidAmount': json['paidAmount'],
        'garnishedAmount': json['garnishedAmount'],
        'expenseAllowance': json['expenseAllowance'],
        'familyAllowance': json['familyAllowance'],
        'employerSettledExpenses': json['employerSettledExpenses'],
        'specialPaymentPaid': json['specialPaymentPaid'],
        'monthlyIncome': json['monthlyIncome'],
        'countsTowardsAverage': json['countsTowardsAverage'],
    };
}

export function AssetIncomeMonthResponseToJSON(json: any): AssetIncomeMonthResponse {
    return AssetIncomeMonthResponseToJSONTyped(json, false);
}

export function AssetIncomeMonthResponseToJSONTyped(value?: AssetIncomeMonthResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'year': value['year'],
        'month': value['month'],
        'paidAmount': value['paidAmount'],
        'garnishedAmount': value['garnishedAmount'],
        'expenseAllowance': value['expenseAllowance'],
        'familyAllowance': value['familyAllowance'],
        'employerSettledExpenses': value['employerSettledExpenses'],
        'specialPaymentPaid': value['specialPaymentPaid'],
        'monthlyIncome': value['monthlyIncome'],
        'countsTowardsAverage': value['countsTowardsAverage'],
    };
}

